import { blueGrey, lightBlue, lightGreen } from '@mui/material/colors';
import { dark } from './dark';
import { light } from './light';

const stage = {
  published: {
    background: lightGreen.A100,
    color: lightGreen[900],
  },
  outdated: {
    background: lightBlue.A200,
    color: lightBlue[900],
  },
  draft: {
    background: blueGrey[200],
    color: blueGrey[900],
  },
};

export { light, dark, stage };
